// extracted by mini-css-extract-plugin
export default {"menu-animate":"MobileMenu_menu-animate__Ezcbr","expandCircle":"MobileMenu_expandCircle__kbaOm","menu-open":"MobileMenu_menu-open__3RbgI","menu-close":"MobileMenu_menu-close__NN9ee"};